import { render, staticRenderFns } from "./SdkMessage.vue?vue&type=template&id=6c6374ba"
import script from "./SdkMessage.vue?vue&type=script&lang=js"
export * from "./SdkMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports